<template>
    <section class="section section-lg section-shaped overflow-hidden my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container shape-container py-0 pb-5">
            <div class="row row-grid justify-content-between align-items-center">
                <div class="col-lg-6">
                    <h3 class="display-3 text-white">Sứ Mệnh
                        
                    </h3>
                    <p class="lead text-white">Không ngừng đổi mới, chuyên nghiệp hóa hệ thống quản trị; thúc đẩy đầu tư một cách toàn diện cho hệ thống kỹ thuật, nhằm phát triển, cung cấp các sản phẩm – dịch vụ chất lượng cao, mang lại những giá trị tốt nhất cho khách hàng. Từ đó xây dựng lòng tin, mối quan hệ gắn bó với khách hàng và đối tác để đi lên bền vững.</p>
                    <div class="btn-wrapper">
                        <router-link to="/login" class="btn btn-success">
                           Chi Tiết
                        </router-link>
                    </div>
                </div>
                <!--
                <div class="col-lg-5 mb-lg-auto">
                    <div class="transform-perspective-right">
                        <card class="border-0" type="secondary" shadow
                              body-classes="px-lg-5 py-lg-5"
                              header-classes="pb-5 bg-white">
                            <template slot="header">
                                <div class="text-muted text-center mb-3">
                                    <small>OCTA</small>
                                </div>
                                <div class="btn-wrapper text-center">
                                    <base-button type="neutral">
                                        <a href="#"><img src="img/brand/octa-googleplay.png" width="120" style=" border-radius: 7px" /></a>
                                    </base-button>

                                    <base-button type="neutral">
                                       <a href="#"><img src="img/brand/octa-app-store.png" width="122" style=" border-radius: 7px" /></a>
                                    </base-button>
                                </div>
                            </template>
                            <template>
                                <div class="text-center text-muted mb-4">
                                    <small>Muốn làm việc với chúng tôi?<br>Dự án của bạn rất quan trọng đối với chúng tôi.</small>
                                </div>
                                <form role="form">
                                    <base-input alternative
                                                placeholder="Email"
                                                addon-left-icon="ni ni-email-83">
                                    </base-input>
                                    <base-input alternative
                                                type="password"
                                                placeholder="Mật Khẩu"
                                                addon-left-icon="ni ni-lock-circle-open">
                                    </base-input>
                                    <base-checkbox>
                                        Nhớ mật khẩu
                                    </base-checkbox>
                                    <div class="text-center">
                                        <base-button type="primary" class="my-4">Đăng Nhập</base-button>
                                    </div>
                                </form>
                            </template>
                        </card>
                    </div>
                </div>
                -->
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
